
export default class LogService {
  static error(message) {
    console.error(message)
  }
}
